module.exports = __webpack_public_path__ + "static/media/logos_squares_Sup_DSD.1d659cc5.png";


//////////////////
// WEBPACK FOOTER
// ./src/image/home/partners_logos/logos_squares_Sup_DSD.png
// module id = 51
// module chunks = 0